import React from 'react'

const Success = () => {
  return (
    <div className="pt-16 bg-slate-100 min-h-[calc(100vh)]">
        <div className='bg-green-200 w-full max-w-md m-auto h-36 flex justify-center items-center font-semibold text-lg'>
            <p>Your Payment is Successfully Done !!!!</p>
        </div>
    </div>
  )
}

export default Success
